// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"4108ce8e","457":"0e68fce2","551":"f08f88f6"}[chunkId] + ".chunk.js";
};